<template>
    <!-- Removida a classe main-content e o header com breadcrumb -->
    <div>
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <!-- Removida a div card p-4 para não ficar com card duplo. Agora os elementos estão soltos para herdar a caixa pai. -->
        <div>
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h5 class="mb-0 fw-bold"></h5>
                    <span class="text-muted fs-7"></span>
                </div>

                <div class="d-flex gap-2 align-items-center">
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="d-flex align-items-center me-2 pe-3 border-end">
                            <button class="btn btn-pmg-danger btn-sm px-3"
                                @click="confirmDelete(selectedIds.length, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{ selectedIds.length }})
                            </button>
                        </div>
                    </transition>

                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <button class="btn btn-pmg-primary" data-bs-toggle="modal" data-bs-target="#modalGateway"
                        @click="openModal('create')">
                        <i class="bi bi-plus-lg me-1"></i> Novo Gateway
                    </button>
                </div>
            </div>

            <!-- TODO O RESTANTE DO SEU TEMPLATE DE GATEWAY CONTINUA AQUI (Filters, Table, Modals) -->
            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3">
                        <div class="col-md-10">
                            <input v-model="filter.name" type="text" class="form-control form-control-pmg"
                                placeholder="Filtrar por nome, provedor ou identificador...">
                        </div>
                        <div class="col-md-2 d-flex">
                            <button class="btn btn-dark w-100 btn-pmg-dark fw-bold" @click="applyFilter">
                                <i class="bi bi-search me-1"></i> Filtrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 25%">Nome / Identificador</th>
                            <th style="width: 15%">Provedor</th>
                            <th style="width: 40%">Métodos Habilitados</th>
                            <th style="width: 15%" class="text-end">Ações</th>
                        </tr>
                    </thead>

                    <tbody v-if="gateways.length > 0">
                        <tr v-for="item in gateways" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td><input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>
                            <td class="fw-bold text-dark">
                                <div class="d-flex flex-column">
                                    <span>{{ item.name }}</span>
                                    <span class="small text-muted fw-normal">/webhooks/{{ item.slug }}</span>
                                </div>
                            </td>
                            <td>
                                <span class="badge bg-light text-dark border text-uppercase">{{ item.provider }}</span>
                            </td>
                            <td>
                                <div class="d-flex gap-2">
                                    <span class="badge rounded-pill"
                                        :class="item.allows_pix ? 'bg-primary-subtle text-primary border' : 'bg-light text-muted border opacity-50'">
                                        <i class="bi bi-qr-code me-1"></i> PIX
                                    </span>
                                    <span class="badge rounded-pill"
                                        :class="item.allows_ticket ? 'bg-info-subtle text-info border' : 'bg-light text-muted border opacity-50'">
                                        <i class="bi bi-file-pdf me-1"></i> Boleto
                                    </span>
                                    <span class="badge rounded-pill"
                                        :class="item.allows_credit_card ? 'bg-success-subtle text-success border' : 'bg-light text-muted border opacity-50'">
                                        <i class="bi bi-credit-card me-1"></i> Cartão
                                    </span>
                                    <span class="badge rounded-pill"
                                        :class="item.allows_checkout ? 'bg-dark text-white border border-dark' : 'bg-light text-muted border opacity-50'">
                                        <i class="bi bi-link-45deg me-1"></i> Link (Checkout)
                                    </span>
                                </div>
                            </td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        data-bs-boundary="viewport">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0">
                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="openModal('edit', item)">
                                                <i class="bi bi-pencil me-2"></i>Editar
                                            </a>
                                        </li>

                                        <li v-if="item.provider != 'pagarme'">
                                            <a class="dropdown-item" href="#"
                                                :class="{ 'disabled text-muted': !item.is_active }"
                                                @click.prevent="item.is_active ? openWebhookModal(item) : null">
                                                <i class="bi bi-cloud-arrow-up-fill me-2 text-primary"></i>Configurar
                                                Webhook
                                            </a>
                                        </li>

                                        <li>
                                            <a class="dropdown-item" href="#" @click.prevent="toggleStatus(item)">
                                                <i class="bi me-2"
                                                    :class="item.is_active ? 'bi-toggle-off text-warning' : 'bi-toggle-on text-success'"></i>
                                                {{ item.is_active ? 'Inativar' : 'Ativar' }}
                                            </a>
                                        </li>

                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>

                                        <li>
                                            <a class="dropdown-item text-danger" href="#"
                                                @click.prevent="confirmDelete(item)">
                                                <i class="bi bi-trash me-2"></i>Excluir
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="5" class="text-center py-5 text-muted">
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <i class="bi bi-inbox fs-1 mb-2 text-secondary opacity-50"></i>
                                    <span class="fw-medium">Nenhum gateway configurado.</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-center mt-4" v-if="hasMore">
                <button
                    class="btn btn-pmg-light px-5 btn-sm fw-bold d-inline-flex align-items-center justify-content-center"
                    @click="loadMore" :disabled="loading" style="min-width: 220px;">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    <span>{{ loading ? 'Carregando...' : 'Carregar mais itens' }}</span>
                </button>
            </div>
        </div>

        <!-- MANTENHA OS MODAIS EXATAMENTE IGUAIS -->
        <div class="modal fade" id="modalGateway" tabindex="-1" aria-hidden="true" ref="modalGateway">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4">
                        <h5 class="fw-bold m-0">{{ isEditing ? 'Editar Gateway' : 'Novo Gateway' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="resetForm"></button>
                    </div>
                    <div class="modal-body px-4">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Nome da Integração</label>
                                <input v-model="form.name" type="text" class="form-control form-control-pmg"
                                    placeholder="Ex: Asaas Loja Sul" @input="generateSlug">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Provedor (Driver)</label>
                                <div class="dropdown w-100">
                                    <button
                                        class="form-select form-control-pmg w-100 text-start d-flex align-items-center justify-content-between"
                                        type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                        :disabled="isEditing" style="padding-top: 9px; padding-bottom: 9px;">

                                        <span v-if="!form.provider" class="text-muted">Selecione o provedor...</span>
                                        <div v-else class="d-flex align-items-center">
                                            <span :class="'provider-icon-mini brand-' + form.provider"
                                                class="me-2"></span>
                                            <span class="fw-semibold text-dark">{{ form.provider === 'efi' ? 'Efí Pay' :
                                                form.provider === 'pagarme' ? 'Pagar.me' : form.provider.toUpperCase()
                                                }}</span>
                                        </div>
                                    </button>

                                    <ul class="dropdown-menu w-100 shadow border-0 p-1 rounded-3">
                                        <li>
                                            <button class="dropdown-item d-flex align-items-center rounded-2 py-2 mb-1"
                                                type="button" @click="form.provider = 'asaas'">
                                                <span class="provider-icon-mini brand-asaas me-3"></span>
                                                <div class="d-flex flex-column" style="min-width: 0;">
                                                    <span class="fw-bold text-dark lh-sm fs-7">Asaas</span>
                                                    <span class="text-muted text-wrap" style="font-size: 0.7rem;">Ideal
                                                        para automação de boletos e réguas de cobrança</span>
                                                </div>
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item d-flex align-items-center rounded-2 py-2 mb-1"
                                                type="button" @click="form.provider = 'pagarme'">
                                                <span class="provider-icon-mini brand-pagarme me-3"></span>
                                                <div class="d-flex flex-column" style="min-width: 0;">
                                                    <span class="fw-bold text-dark lh-sm fs-7">Pagar.me</span>
                                                    <span class="text-muted text-wrap"
                                                        style="font-size: 0.7rem;">Excelente para alta conversão em
                                                        cartões e split de checkout</span>
                                                </div>
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item d-flex align-items-center rounded-2 py-2 mb-1"
                                                type="button" @click="form.provider = 'stripe'">
                                                <span class="provider-icon-mini brand-stripe me-3"></span>
                                                <div class="d-flex flex-column" style="min-width: 0;">
                                                    <span class="fw-bold text-dark lh-sm fs-7">Stripe</span>
                                                    <span class="text-muted text-wrap"
                                                        style="font-size: 0.7rem;">Infraestrutura global para pagamentos
                                                        internacionais e SaaS</span>
                                                </div>
                                            </button>
                                        </li>
                                        <li>
                                            <button class="dropdown-item d-flex align-items-center rounded-2 py-2"
                                                type="button" @click="form.provider = 'efi'">
                                                <span class="provider-icon-mini brand-efi me-3"></span>
                                                <div class="d-flex flex-column" style="min-width: 0;">
                                                    <span class="fw-bold text-dark lh-sm fs-7">Efí Pay</span>
                                                    <span class="text-muted text-wrap"
                                                        style="font-size: 0.7rem;">Especialista em Pix de alta
                                                        performance com mTLS</span>
                                                </div>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="form-label small fw-bold text-muted">Identificador Único (Slug
                                    Webhook)</label>
                                <div class="input-group">
                                    <span
                                        class="input-group-text bg-light border-end-0 small text-muted">/webhooks/</span>
                                    <input v-model="form.slug" type="text"
                                        class="form-control form-control-pmg border-start-0"
                                        placeholder="identificador-unico" :disabled="isEditing">
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="form-label small fw-bold text-muted">URL Base da API</label>
                                <input v-model="form.base_url" type="url" class="form-control form-control-pmg"
                                    placeholder="https://api.asaas.com/v3">
                            </div>

                            <div class="col-12" v-if="form.provider === 'efi'">
                                <div class="row g-2">
                                    <div class="col-md-6">
                                        <label class="form-label small fw-bold text-muted">Client ID</label>
                                        <input v-model="form.credentials.client_id" type="text"
                                            class="form-control form-control-pmg" placeholder="123456">
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label small fw-bold text-muted">Client Secret</label>
                                        <input v-model="form.credentials.client_secret" type="password"
                                            class="form-control form-control-pmg" placeholder="********">
                                    </div>
                                    <div class="col-12">
                                        <label class="form-label small fw-bold text-muted">Chave Pix</label>
                                        <input v-model="form.credentials.pix_key" type="text"
                                            class="form-control form-control-pmg" placeholder="****************">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-else>
                                <label class="form-label small fw-bold text-muted">API Key / Token</label>
                                <div class="input-group">
                                    <input :type="showApiKey ? 'text' : 'password'" v-model="form.credentials.api_key"
                                        class="form-control form-control-pmg"
                                        style="border-top-right-radius: 0; border-bottom-right-radius: 0;"
                                        placeholder="********">
                                    <button class="btn btn-light border border-start-0"
                                        style="border-top-right-radius: 10px; border-bottom-right-radius: 10px;"
                                        type="button" @click="showApiKey = !showApiKey">
                                        <i class="bi" :class="showApiKey ? 'bi-eye-slash' : 'bi-eye'"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12" v-if="form.provider === 'efi'">
                                <label class="form-label small fw-bold text-muted">Certificado (MTLS .pem/.p12)</label>
                                <input type="file" class="form-control form-control-pmg" @change="handleFileUpload"
                                    accept=".pem,.p12">
                                <div class="small text-muted mt-1" v-if="form.path_certificate">
                                    <i class="bi bi-check-circle text-success"></i> Arquivo atual já configurado.
                                </div>
                            </div>

                            <div class="col-12 mt-2">
                                <label class="form-label small fw-bold text-muted mb-2">Métodos de Pagamento
                                    Habilitados</label>
                                <div class="d-flex flex-wrap gap-3 p-3 bg-light rounded-3 border">
                                    <div class="form-check form-switch"><input class="form-check-input" type="checkbox"
                                            v-model="form.allows_pix" id="checkPix"><label
                                            class="form-check-label fw-bold small" for="checkPix">PIX</label></div>
                                    <div class="form-check form-switch"><input class="form-check-input" type="checkbox"
                                            v-model="form.allows_ticket" id="checkBoleto"><label
                                            class="form-check-label fw-bold small" for="checkBoleto">Boleto</label>
                                    </div>
                                    <div class="form-check form-switch"><input class="form-check-input" type="checkbox"
                                            v-model="form.allows_credit_card" id="checkCard"><label
                                            class="form-check-label fw-bold small" for="checkCard">Cartão</label></div>
                                    <div class="form-check form-switch"><input class="form-check-input" type="checkbox"
                                            v-model="form.allows_checkout" id="checkCheckout"><label
                                            class="form-check-label fw-bold small" for="checkCheckout">Link
                                            (Checkout)</label></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pb-4 px-4">
                        <button class="btn btn-pmg-light me-2" data-bs-dismiss="modal"
                            @click="resetForm">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4" :disabled="loadingSave" @click="saveGateway">
                            <span v-if="loadingSave" class="spinner-border spinner-border-sm me-2"></span>
                            {{ isEditing ? 'Atualizar' : 'Salvar Gateway' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true" ref="confirmDeleteModal">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3"><i class="bi bi-exclamation-triangle-fill fs-1"></i></div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">
                            {{ isBulkDelete ? `Excluir ${selectedIds.length} gateways selecionados?` : `Excluir
                            "${itemToDelete?.name}"?` }}
                        </p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="confirmWebhookModal" tabindex="-1" aria-hidden="true" ref="confirmWebhookModal">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-primary mb-3">
                            <i class="bi bi-cloud-check-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Webhook Automático</h5>
                        <p class="text-muted small">
                            Deseja configurar automaticamente o webhook para o gateway <strong>"{{ itemToWebhook?.name
                                }}"</strong>?
                        </p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-light px-4" data-bs-dismiss="modal"
                            :disabled="isConfiguringWebhook">Cancelar</button>

                        <button class="btn btn-primary px-4 rounded-3 d-flex align-items-center gap-2"
                            @click="executeWebhookConfiguration" :disabled="isConfiguringWebhook">
                            <span v-if="isConfiguringWebhook" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                            {{ isConfiguringWebhook ? 'Configurando...' : 'Confirmar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/services/api';

export default {
    inject: ['globalLoading'],
    data() {
        return {
            gateways: [],
            alerts: [],
            isEditing: false,
            form: {
                id: null, name: '', provider: '', slug: '',
                base_url: '',
                credentials: { api_key: '', client_id: '', client_secret: '', pix_key: '' },
                allows_pix: true, allows_ticket: true, allows_credit_card: true, allows_checkout: true
            },
            certificateFile: null,
            selectedIds: [],
            filter: { name: '' },
            showApiKey: false,
            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            loading: false,
            loadingSave: false,
            hasMore: false,
            showFilter: false,
            modalInstance: null,
            confirmDeleteModalInstance: null,
            itemToDelete: null,
            isBulkDelete: false,
            itemToWebhook: null,
            isConfiguringWebhook: false,
            webhookModalInstance: null,
        }
    },
    computed: {
        isAllSelected() { return this.gateways.length > 0 && this.gateways.every(i => this.selectedIds.includes(i.id)); },
        isFormValid() { return this.form.name && this.form.provider && this.form.slug && this.form.base_url; }
    },
    mounted() {
        this.modalInstance = new window.bootstrap.Modal(this.$refs.modalGateway);
        this.confirmDeleteModalInstance = new window.bootstrap.Modal(this.$refs.confirmDeleteModal);
        this.webhookModalInstance = new window.bootstrap.Modal(this.$refs.confirmWebhookModal);
        
        this.fetchGateways();
    },
    methods: {
        async fetchGateways(page = 1, append = false) {
            this.globalLoading.show('Carregando...');
            this.loading = true;
            try {
                const response = await api.get('/payment-gateways', { params: { page, search: this.filter.name } });
                const payload = response.data;
                const items = Array.isArray(payload) ? payload : (payload.data || []);
                const paginationData = payload.meta || payload;
                this.gateways = append ? [...this.gateways, ...items] : items;
                this.currentPage = paginationData.current_page;
                this.lastPage = paginationData.last_page;
                this.totalItems = paginationData.total;
                this.hasMore = this.currentPage < this.lastPage;
            } catch (error) { this.showAlert('Falha ao buscar gateways.', 'error'); }
            finally { this.loading = false; this.globalLoading.hide(); }
        },
        generateSlug() {
            if (!this.isEditing && this.form.name) {
                this.form.slug = this.form.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
            }
        },
        openModal(mode, item = null) {
            this.showApiKey = false;
            if (mode === 'edit') {
                this.isEditing = true;
                this.form = {
                    ...item,
                    credentials: item.credentials || { api_key: '', client_id: '', client_secret: '', pix_key: '' },
                    allows_pix: !!item.allows_pix,
                    allows_ticket: !!item.allows_ticket,
                    allows_credit_card: !!item.allows_credit_card,
                    allows_checkout: !!item.allows_checkout,
                    is_active: !!item.is_active
                };
            } else {
                this.resetForm();
            }
            if (this.modalInstance) this.modalInstance.show();
        },
        handleFileUpload(event) { this.certificateFile = event.target.files[0]; },
        async saveGateway() {
            this.loadingSave = true;
            const formData = new FormData();

            Object.keys(this.form).forEach(key => {
                if (key === 'credentials') return;
                const val = this.form[key];
                if (val !== null && val !== undefined) {
                    formData.append(key, typeof val === 'boolean' ? (val ? '1' : '0') : val);
                }
            });

            formData.append('credentials', JSON.stringify(this.form.credentials));
            if (this.certificateFile) formData.append('certificate', this.certificateFile);
            if (this.isEditing) formData.append('_method', 'PUT');

            try {
                this.globalLoading.show('Salvando...');
                const url = this.isEditing ? `/payment-gateways/${this.form.id}` : '/payment-gateways';
                await api.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                this.showAlert("Salvo com sucesso!");
                this.modalInstance.hide();
                this.fetchGateways(1, false);
                this.resetForm();
            } catch (e) {
                this.showAlert("Erro ao salvar: " + (e.response?.data?.message || 'Erro desconhecido'), "error");
            } finally {
                this.loadingSave = false;
                this.globalLoading.hide();
            }
        },
        confirmDelete(target, isBulk = false) {
            this.itemToDelete = isBulk ? null : target;
            this.isBulkDelete = isBulk;
            this.confirmDeleteModalInstance.show();
        },
        async executeDeletion() {
            try {
                if (this.isBulkDelete) {
                    await api.post('/payment-gateways/bulk-delete', { ids: this.selectedIds });
                } else {
                    await api.delete(`/payment-gateways/${this.itemToDelete.id}`);
                }
                this.showAlert("Removido com sucesso.");
                this.selectedIds = [];
                this.fetchGateways(1, false);
            } catch (error) {
                this.showAlert('Erro ao excluir registro.', 'error');
            } finally {
                this.confirmDeleteModalInstance.hide();
            }
        },
        async toggleStatus(item) {
            try {
                await api.patch(`/payment-gateways/${item.id}/toggle`);
                item.is_active = !item.is_active;
                this.showAlert(`Gateway ${item.is_active ? 'ativado' : 'inativado'}.`);
            } catch (error) {
                this.showAlert("Erro ao alterar status.", 'error');
            }
        },
        toggleAll(e) { this.selectedIds = e.target.checked ? this.gateways.map(c => c.id) : []; },
        showAlert(message, type = 'success') {
            const id = Date.now();
            this.alerts.push({ id, message, type, icon: type === 'error' ? 'bi-x-circle-fill' : 'bi-check-circle-fill' });
            setTimeout(() => this.alerts = this.alerts.filter(a => a.id !== id), 4000);
        },
        removeAlert(id) { this.alerts = this.alerts.filter(a => a.id !== id); },
        resetForm() {
            this.isEditing = false;
            this.certificateFile = null;
            this.form = {
                id: null, name: '', provider: '', slug: '', base_url: '',
                credentials: { api_key: '', client_id: '', client_secret: '', pix_key: '' },
                allows_pix: true, allows_ticket: true, allows_credit_card: true, allows_checkout: true
            };
        },
        applyFilter() { this.fetchGateways(1, false); },
        loadMore() { if (this.hasMore) this.fetchGateways(this.currentPage + 1, true); },
        // 1. Método pra abrir o modal e guardar qual gateway foi o escolhido
        openWebhookModal(gateway) {
            this.itemToWebhook = gateway;
            if (this.webhookModalInstance) {
                this.webhookModalInstance.show();
            }
        },

        // 2. Método que vai lá no back-end meter o pé na porta e configurar tudo
        async executeWebhookConfiguration() {
            if (!this.itemToWebhook) return;

            this.isConfiguringWebhook = true;

            try {
                // Dispara o POST pro endpoint que a gente criou no Laravel
                const response = await api.post(`/payment-gateways/${this.itemToWebhook.id}/configure-webhook`);

                // Se teu projeto usa aquele array de alerts/toasts que vimos antes, taca ele aqui:
                this.alerts.push({
                    id: Date.now(),
                    type: 'success',
                    icon: 'bi-check-circle-fill',
                    message: response.data.message
                });

                // Fecha o modal bem bonitinho
                if (this.webhookModalInstance) {
                    this.webhookModalInstance.hide();
                }

            } catch (error) {
                // Se o Asaas der chilique ou o token tiver errado, joga o erro na tela
                const errorMsg = error.response?.data?.message || 'Vixe! Deu alguma bronca ao tentar configurar o webhook.';

                this.alerts.push({
                    id: Date.now(),
                    type: 'danger',
                    icon: 'bi-exclamation-triangle-fill',
                    message: errorMsg
                });
            } finally {
                // Destrava os botões e limpa o estado
                this.isConfiguringWebhook = false;
            }
        }
    }
}
</script>
<style scoped>
/* Remova apenas a classe .main-content e .card do style original. O restante fica igual. */
.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.7rem;
    text-transform: uppercase;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.selected-row {
    background-color: #f8fafc;
}

.table-responsive {
    overflow: visible !important;
}

.bg-primary-subtle {
    background-color: #e0e7ff !important;
    color: #4338ca !important;
    border-color: #c7d2fe !important;
}

.bg-info-subtle {
    background-color: #e0f2fe !important;
    color: #0369a1 !important;
    border-color: #bae6fd !important;
}

.bg-success-subtle {
    background-color: #dcfce7 !important;
    color: #15803d !important;
    border-color: #bbf7d0 !important;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #991b1b !important;
    border-left: 5px solid #ef4444 !important;
}
</style>